/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import { DropdownButtonsProps } from 'types/components/Dropdown';
import { WatchTvSection } from 'types/components/WatchTv';
import { Close } from '..';

export default function DropdownButtons({ buttons, closeDropdown, section }: DropdownButtonsProps) {
  return buttons ? (
    <div className="buttons-container" id="DropdownButtons">
      {section === WatchTvSection.ON_NOW && (
        <div className="close-container">
          <Close bemBlock="DropdownButtons" action={closeDropdown} isActive />
        </div>
      )}
      {buttons.map((button) => {
        return (
          <a key={button.id} className="button" onClick={button.onClick} id={`DropdownButtons_button___${button.id}`}>
            <span className="button-text" id={`DropdownButtons_text___${button.id}`}>
              {button.text}
            </span>
            {button.selected && <span className="option-active" id={`DropdownButtons_selected___${button.id}`} />}
          </a>
        );
      })}
    </div>
  ) : null;
}
